import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { MainIcon, MenuIcon } from "../../../icons/index";
import {
  Button,
  Card,
  CardBody,
  Avatar,
  Badge,
  Dropdown,
  DropdownItem,
} from "@windmill/react-ui";

import { AuthContext } from "../../../context/AuthContext";
import Logo from "../../../assets/img/logo-gfm.png";

function Buttons() {
  const { user } = useContext(AuthContext);
  return (
    <div className="hidden sm:flex gap-6">
      {!user && (
        <Link to="#">
          <Button>Log In</Button>
        </Link>
      )}
      {!user && (
        <Link to="#">
          <Button layout="link">Open Account</Button>
        </Link>
      )}
      {user && (
        <Link to="/app">
          <Button>Dashboard</Button>
        </Link>
      )}
    </div>
  );
}

function NavbarContent({}) {
  const { user } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex space-y-4 lg:space-y-0 lg:space-x-4 hidden lg:block">
      <div className="items-baseline grid grid-cols-1 lg:grid-cols-auto lg:grid-rows-1 lg:grid-flow-col gap-4 text-sm font-medium text-gray-200 ">
        <div className="items-baseline grid grid-cols-1 lg:grid-cols-auto lg:grid-rows-1 lg:grid-flow-col gap-4 text-sm font-medium text-gray-200">
          <div className="">
            <Link
              to="/"
              className="hover:text-yellow-400 text-base transition ease-in-out"
            >
              HOME
            </Link>
            {location.pathname == "/" && (
              <div className="animate-bounce bg-yellow-500 w-full h-1 rounded-lg"></div>
            )}
          </div>

          {/* platforms */}
          <div>
            <Link
              to="/platform"
              className="hover:text-yellow-400 text-base transition ease-in-out"
            >
              PLATFORM
            </Link>
            {location.pathname == "/platform" && (
              <div className="animate-bounce bg-yellow-500 w-full h-1 rounded-lg"></div>
            )}
          </div>

          {/* trading */}
          <div onClick={() => setIsOpen(!isOpen)}>
            <Link
              to="#"
              className="hover:text-yellow-400 text-base transition ease-in-out relative"
              onClick={() => setIsOpen(!isOpen)}
            >
              TRADING
              <Dropdown
                className="z-10 flex flex-col gap-2 px-4 py-4"
                isOpen={isOpen}
                onClose={isOpen}
              >
                <Link
                  to="/trading/account-type"
                  className="hover:text-yellow-400 text-sm transition ease-in-out"
                >
                  ACCOUNT TYPE
                </Link>
                <Link
                  to="/trading/funding"
                  className="hover:text-yellow-400 text-sm transition ease-in-out"
                >
                  FUNDING
                </Link>
                <Link
                  to="/trading/platform-tools"
                  className="hover:text-yellow-400 text-sm transition ease-in-out"
                >
                  PLATFORM TOOLS
                </Link>
              </Dropdown>
            </Link>
            {location.pathname.includes("/trading") && (
              <div className="animate-bounce bg-yellow-500 w-full h-1 rounded-lg"></div>
            )}

            {/* <div className="animate-bounce bg-yellow-500 w-full h-1 rounded-lg"></div> */}
          </div>

          {/* why us */}
          <div>
            <Link
              to="/whyus"
              className="hover:text-yellow-400 text-base transition ease-in-out"
            >
              WHY US
            </Link>
            {location.pathname == "/whyus" && (
              <div className="animate-bounce bg-yellow-500 w-full h-1 rounded-lg"></div>
            )}
          </div>

          {/* learning ebook */}
          {/* <div>
            <Link
              to={{
                pathname:
                  "https://drive.google.com/file/d/10bmXD0JyOqoefxJgk-OkjllmF0yuvOUv/view?usp=share_link",
              }}
              className="hover:text-yellow-400 text-base transition ease-in-out"
              target="_blank"
            >
              LEARNING EBOOK
            </Link>
            {location.pathname == "/ebook" && (
              <div className="animate-bounce bg-yellow-500 w-full h-1 rounded-lg"></div>
            )}
          </div> */}

          <div>
            <Link
              to='/learning-book'
              className="hover:text-yellow-400 text-base transition ease-in-out"
            >
              LEARNING EBOOK
            </Link>
            {location.pathname == "/ebook" && (
              <div className="animate-bounce bg-yellow-500 w-full h-1 rounded-lg"></div>
            )}
          </div>

          {/* offers */}
          {/* <div>
            <Link
              to="/offers"
              className="hover:text-yellow-400 text-base transition ease-in-out"
            >
              OFFERS
            </Link>
            {location.pathname == "/offers" && (
              <div className="animate-bounce bg-yellow-500 w-full h-1 rounded-lg"></div>
            )}
          </div> */}

          {/* about */}
          <div>
            <Link
              to="/about"
              className="hover:text-yellow-400 text-base transition ease-in-out"
            >
              ABOUT
            </Link>
            {location.pathname == "/about" && (
              <div className="animate-bounce bg-yellow-500 w-full h-1 rounded-lg"></div>
            )}
          </div>

          {/* contact */}
          <div>
            <Link
              to="/contact"
              className="hover:text-yellow-400 text-base transition ease-in-out"
            >
              CONTACT
            </Link>
            {location.pathname == "/contact" && (
              <div className="animate-bounce bg-yellow-500 w-full h-1 rounded-lg"></div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const Header = ({ setActiveTab, activeTab }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const locationMobile = useLocation();

  useEffect(() => {
    setIsMenuOpen(false);
  }, [locationMobile.pathname]);
  return (
    <div className="bg-gray-900">
      <div className="px-4 py-2 mx-auto sm:max-w-xl md:max-w-full md:px-24 lg:px-8">
        <div className="relative flex items-center justify-between">
          <img style={{ height: "4rem" }} src={Logo} />
          <NavbarContent />
          <div className="flex gap-5">
            <Buttons />
            <button
              aria-label="Open Menu"
              title="Open Menu"
              className="p-2 -mr-1 transition duration-200 rounded focus:outline-none focus:shadow-outline lg:hidden"
              onClick={() => setIsMenuOpen(true)}
            >
              <svg className="w-5 text-gray-600" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z"
                />
                <path
                  fill="currentColor"
                  d="M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z"
                />
                <path
                  fill="currentColor"
                  d="M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z"
                />
              </svg>
            </button>
          </div>
          {isMenuOpen && (
            <div className="absolute top-0 left-0 w-full z-10">
              <div className="p-5 bg-white border rounded shadow-sm">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <a
                      href="/"
                      aria-label="Company"
                      title="Company"
                      className="inline-flex items-center"
                    >
                      <svg
                        className="w-8 text-deep-purple-accent-400"
                        viewBox="0 0 24 24"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeMiterlimit="10"
                        stroke="currentColor"
                        fill="none"
                      >
                        <rect x="3" y="1" width="7" height="12" />
                        <rect x="3" y="17" width="7" height="6" />
                        <rect x="14" y="1" width="7" height="6" />
                        <rect x="14" y="11" width="7" height="12" />
                      </svg>
                      <span className="ml-2 text-lg font-bold tracking-wide text-gray-800 uppercase">
                        Global FX
                      </span>
                    </a>
                  </div>
                  <div>
                    <button
                      aria-label="Close Menu"
                      title="Close Menu"
                      className="p-2 -mt-2 -mr-2 transition duration-200 rounded hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      <svg className="w-5 text-gray-600" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M19.7,4.3c-0.4-0.4-1-0.4-1.4,0L12,10.6L5.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.3,6.3l-6.3,6.3 c-0.4,0.4-0.4,1,0,1.4C4.5,19.9,4.7,20,5,20s0.5-0.1,0.7-0.3l6.3-6.3l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12l6.3-6.3C20.1,5.3,20.1,4.7,19.7,4.3z"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <nav>
                  <ul className="space-y-4">
                    <li>
                      <Link
                        to="/"
                        aria-label="Home"
                        title="Home"
                        className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-yellow-400"
                      >
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/platform"
                        aria-label="Platform"
                        title="Platform"
                        className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-yellow-400"
                      >
                        Platform
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/trading/account-type"
                        aria-label="Account Types"
                        title="Account Types"
                        className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-yellow-400"
                      >
                        Account Types
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/trading/funding"
                        aria-label="Funding"
                        title="Funding"
                        className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-yellow-400"
                      >
                        Funding
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/whyus"
                        aria-label="Why us"
                        title="Why us"
                        className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-yellow-400"
                      >
                        Why us
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname:
                            "https://drive.google.com/file/d/10bmXD0JyOqoefxJgk-OkjllmF0yuvOUv/view?usp=share_link",
                        }}
                        target="_blank"
                        aria-label="Learning EBook"
                        title="Learning EBook"
                        className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-yellow-400"
                      >
                        Learning EBook
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/offers"
                        aria-label="Offers"
                        title="Offers"
                        className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-yellow-400"
                      >
                        Offers
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/about"
                        aria-label="About us"
                        title="About us"
                        className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-yellow-400"
                      >
                        About
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/contact"
                        aria-label="Contact"
                        title="Contact"
                        className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-yellow-400"
                      >
                        Contact
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/auth/create-account"
                        className="inline-flex items-center justify-center w-full h-12 px-6 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-yellow-400 hover:bg-yellow-500 focus:shadow-outline focus:outline-none"
                        aria-label="Sign up"
                        title="Sign up"
                      >
                        Sign up
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* <style jsx>{`
        .logInBtn:hover .logInBtn:focus {
          background: #000;
        }
      `}</style> */}
    </div>
  );
};

export default Header;
